// Traduit les messages backend (en anglais) vers le français.
// Recherche exacte d'abord, puis recherche partielle (mots-clés).

const exactMap = {
  'User archived successfully': 'Administrateur archivé avec succès',
  'User unarchived successfully': 'Administrateur désarchivé avec succès',
  'User suspended successfully': 'Utilisateur suspendu avec succès',
  'User reactivated successfully': 'Utilisateur réactivé avec succès',
  'User not found': 'Utilisateur introuvable',
  'User already exists': 'Cet utilisateur existe déjà',
  'Email address is not exist': 'Adresse email inexistante',
  'Email already exists': 'Cette adresse email est déjà utilisée',
  'Phone already exists': 'Ce numéro de téléphone est déjà utilisé',
  'Invalid credentials': 'Identifiants invalides',
  'Invalid token': 'Session invalide, veuillez vous reconnecter',
  'Token expired': 'Session expirée, veuillez vous reconnecter',
  Unauthorized: 'Action non autorisée',
  Forbidden: 'Accès refusé',
  'Internal server error': 'Erreur interne du serveur',
  'Bad request': 'Requête invalide',
  'Not found': 'Ressource introuvable',
  'id is required': 'Identifiant requis',
  'userId is required': 'Identifiant utilisateur requis',
  'email is required': 'Email requis',
  'phone is required': 'Numéro de téléphone requis',
  'password is required': 'Mot de passe requis',
  'You are not allowed': 'Action non autorisée',
  'Permission denied': 'Permission refusée'
}

const keywordMap = [
  { match: /vous n'êtes pas admin ssr/i, fr: 'Vous n\'êtes pas administrateur SSR' },
  { match: /not admin ssr|not an admin/i, fr: 'Vous n\'êtes pas administrateur SSR' },
  { match: /is required/i, fr: 'Champ requis manquant' },
  { match: /already exists?/i, fr: 'Cet élément existe déjà' },
  { match: /not found/i, fr: 'Ressource introuvable' },
  { match: /unauthorized/i, fr: 'Action non autorisée' },
  { match: /forbidden/i, fr: 'Accès refusé' },
  { match: /invalid/i, fr: 'Donnée invalide' },
  { match: /internal server error/i, fr: 'Erreur interne du serveur' }
]

export function translateBackendMessage (message) {
  if (!message || typeof message !== 'string') return message
  if (exactMap[message]) return exactMap[message]
  for (const entry of keywordMap) {
    if (entry.match.test(message)) return entry.fr
  }
  return message
}

export default translateBackendMessage
